// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { useContext, useEffect } from 'react';
import { Avatar, IconButton, Menu, MenuItem, Typography, Stack } from '@mui/material';
import FlagEn from '@/assets/images/flag/icon-flag-en.svg';
import FlagDe from '@/assets/images/flag/icon-flag-de.svg';
import FlagRu from '@/assets/images/flag/icon-flag-ru.svg';
import FlagPl from '@/assets/images/flag/icon-flag-pl.svg';
import FlagUk from '@/assets/images/flag/icon-flag-uk.svg';
import { useTranslation as useI18nTranslation } from 'react-i18next';

import { CustomizerContext } from '@/context/CustomizerContext';
import { useTranslation } from '@/hooks/useTranslation';

const Languages = [
  {
    flagname: 'English (UK)',
    icon: FlagEn,
    value: 'en',
  },
  {
    flagname: 'Deutsch (German)',
    icon: FlagDe,
    value: 'de',
  },
  {
    flagname: 'Русский (Russian)',
    icon: FlagRu,
    value: 'ru',
  },
  {
    flagname: 'Polski (Polish)',
    icon: FlagPl,
    value: 'pl',
  },
  {
    flagname: 'Українська (Ukrainian)',
    icon: FlagUk,
    value: 'uk',
  },
];

const Language = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const { isLanguage, setIsLanguage } = useContext(CustomizerContext);
  const { changeLanguage } = useTranslation();
  const { i18n } = useI18nTranslation();

  // Використовуємо мову з i18n як джерело правди, а не з CustomizerContext
  const currentI18nLanguage = i18n.language;
  const currentLang =
    Languages.find((_lang) => _lang.value === currentI18nLanguage) || Languages[0];
  
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  // Синхронізуємо CustomizerContext з i18n при зміні мови (тільки якщо вони відрізняються)
  useEffect(() => {
    if (isLanguage !== currentI18nLanguage) {
      setIsLanguage(currentI18nLanguage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentI18nLanguage]); // Видаляємо isLanguage та setIsLanguage з залежностей

  const handleLanguageChange = async (languageCode: string) => {
    setIsLanguage(languageCode);
    await changeLanguage(languageCode);
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar src={currentLang.icon} alt={currentLang.value} sx={{ width: 20, height: 20 }} />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiMenu-paper': {
            width: '250px',
          },
        }}
      >
        {Languages.map((option, index) => (
          <MenuItem
            key={index}
            sx={{ py: 2, px: 3 }}
            onClick={() => handleLanguageChange(option.value)}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar src={option.icon} alt={option.icon} sx={{ width: 20, height: 20 }} />
              <Typography> {option.flagname}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Language;
